import { Component, OnInit, ViewChild } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { fuseAnimations } from '../../../core/animations';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatSort, MatPaginator } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { ApiService } from '../../../core/services/api.service';
import { environment } from '../../../../environments/environment';
import { AngularFirestore } from 'angularfire2/firestore';


@Component({
    selector: 'app-keyword-list',
    templateUrl: './keyword-list.component.html',
    styleUrls: ['./keyword-list.component.scss'],
    animations: fuseAnimations
})
export class KeywordListComponent implements OnInit {
    selected = 'şikayet';
    displayedColumns = ['product', 'name', 'job'];
    dataSource: MyDataSource;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    data = [];
    brand: any;
    category: any;
    brands: any;
    brandList = [];
    number: any;
    categories = environment.categoriesModel;
    constructor(private http: Http, private api: ApiService, private afs: AngularFirestore) {




    }

    ngOnInit() {
    }

    someMethod(data) {

        this.data = [];
        this.brandList = [];
        this.afs.collection('brands').ref.where('category', '==', data).get().then(data => {
            data.forEach(brands => {

                this.brandList.push(brands.data().name);

            });
        });
        this.api.sqlPost('corporate/keywordCategoryProcedure', { category: data }).map(res => res.json()).toPromise().then(element => {
            this.number = element.length;
            element.forEach(elem => {
                console.log(elem);
                let json = {
                    "row": elem.row,
                    "keyword": elem.keyword,
                    "keywordCount": elem.keywordCount
                }
                this.data.push(json);
            })
            this.dataSource = new MyDataSource(this.data, this.paginator, this.sort);
        });

    }
    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }
    getBrand(brand) {
        this.data = [];
        this.api.sqlPost('corporate/keywordBrandProcedure', { uniqueName: this.changeText(brand) }).map(res => res.json()).toPromise().then(element => {
            this.number = element.length;
            element.forEach(elem => {
                console.log(elem);
                let json = {
                    "row": elem.row,
                    "keyword": elem.keyword,
                    "keywordCount": elem.keywordCount
                }
                this.data.push(json);
            })
            this.dataSource = new MyDataSource(this.data, this.paginator, this.sort);
        });

    }

}

export class MyDataSource extends DataSource<any> {
    constructor(
        private data: any,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
    }
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.data,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.data.slice();

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    sortData(data): any[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;
                case 'categories':
                    [propertyA, propertyB] = [a.categories[0], b.categories[0]];
                    break;
                case 'price':
                    [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                    break;
                case 'quantity':
                    [propertyA, propertyB] = [a.quantity, b.quantity];
                    break;
                case 'active':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect() { }

}





// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/keyword-list/keyword-list.component.ts